module.exports = __webpack_public_path__ + "img/knus_gallery2.f591498a.jpg";